"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Role;
(function (Role) {
    Role["SuperAdmin"] = "SuperAdmin";
    Role["Admin"] = "Admin";
    Role["Trainer"] = "Trainer";
    Role["AssistantTrainer"] = "AssistantTrainer";
    Role["Client"] = "Client";
})(Role || (Role = {}));
exports.default = Role;
//# sourceMappingURL=Role.js.map